module.exports = __webpack_public_path__ + "static/media/targ_empty.870e36c0.svg";